import DeptApi from '../../../api/src/basic/api/DeptApi'

const deptApi = new DeptApi();

const state = {
    deptList: []
}

const mutations = {
    addDeptList(state, data = []) {
        state.deptList = data
    },
}

const actions = {
    // 获取全部院系
    initPageDept: ({commit, state})=>{
        deptApi.list().then(res=>{
            commit('addDeptList',res || [])
        })
    },
    // 分页获取院系
    pageDept: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            console.log(query)
            deptApi.page(query.pageNum).then(res => {
                resolve(res)
            }).catch(err => {
                resolve(err)
            })
        })
    },
    // 添加课程
    addDept: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            deptApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 删除课程
    delDept: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            deptApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 修改课程
    editDept: ({commit, state}, query) => {
        console.log(query)
        return new Promise((resolve, reject) => {
            deptApi.update(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
                this.$message.error(err.message)
            })
        })
    }
}

export default {
    state,
    actions,
    mutations
}